export default __webpack_public_path__ + "static/media/logo.6230d1a4.png";